import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "admin-dashboard" };
const _hoisted_2 = { class: "dashboard-content" };
const _hoisted_3 = {
    class: "metric-grid",
    "aria-label": "Order overview"
};
const _hoisted_4 = { class: "metric-card" };
const _hoisted_5 = { class: "metric-icon purple-icon" };
const _hoisted_6 = { class: "metric-card" };
const _hoisted_7 = { class: "metric-icon blue-icon" };
const _hoisted_8 = { class: "metric-card" };
const _hoisted_9 = { class: "metric-icon navy-icon" };
const _hoisted_10 = { class: "metric-card" };
const _hoisted_11 = { class: "metric-icon violet-icon" };
const _hoisted_12 = {
    class: "insights-grid",
    "aria-label": "Sales insights"
};
const _hoisted_13 = { class: "panel" };
const _hoisted_14 = { class: "panel-header" };
const _hoisted_15 = { class: "empty-state" };
const _hoisted_16 = { class: "empty-icon" };
const _hoisted_17 = { class: "panel" };
const _hoisted_18 = { class: "panel-header" };
const _hoisted_19 = { class: "empty-state" };
const _hoisted_20 = { class: "empty-icon" };
const _hoisted_21 = { class: "panel recent-panel" };
const _hoisted_22 = { class: "panel-header" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ClipboardList = _resolveComponent("ClipboardList");
    const _component_Clock3 = _resolveComponent("Clock3");
    const _component_Package = _resolveComponent("Package");
    const _component_CircleDollarSign = _resolveComponent("CircleDollarSign");
    const _component_TrendingUp = _resolveComponent("TrendingUp");
    const _component_Users = _resolveComponent("Users");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("header", { class: "dashboard-header" }, [
                _createElementVNode("div", null, [
                    _createElementVNode("p", { class: "eyebrow" }, "BUSINESS OVERVIEW"),
                    _createElementVNode("h1", null, "Dashboard"),
                    _createElementVNode("p", { class: "dashboard-description" }, "Orders, product performance, and client spending.")
                ])
            ], -1)),
            _createElementVNode("section", _hoisted_3, [
                _createElementVNode("article", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_ClipboardList, {
                            size: 20,
                            "aria-hidden": "true"
                        })
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "metric-copy" }, [
                        _createElementVNode("p", null, "Total orders"),
                        _createElementVNode("strong", null, "—"),
                        _createElementVNode("span", null, "All recorded orders")
                    ], -1))
                ]),
                _createElementVNode("article", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_Clock3, {
                            size: 20,
                            "aria-hidden": "true"
                        })
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "metric-copy" }, [
                        _createElementVNode("p", null, "Open orders"),
                        _createElementVNode("strong", null, "—"),
                        _createElementVNode("span", null, "Awaiting completion")
                    ], -1))
                ]),
                _createElementVNode("article", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Package, {
                            size: 20,
                            "aria-hidden": "true"
                        })
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "metric-copy" }, [
                        _createElementVNode("p", null, "Best-selling product"),
                        _createElementVNode("strong", { class: "metric-value-text" }, "—"),
                        _createElementVNode("span", null, "Ranked by units sold")
                    ], -1))
                ]),
                _createElementVNode("article", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_CircleDollarSign, {
                            size: 20,
                            "aria-hidden": "true"
                        })
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "metric-copy" }, [
                        _createElementVNode("p", null, "Top client spend"),
                        _createElementVNode("strong", null, "—"),
                        _createElementVNode("span", null, "Highest order total")
                    ], -1))
                ])
            ]),
            _createElementVNode("section", _hoisted_12, [
                _createElementVNode("article", _hoisted_13, [
                    _createElementVNode("header", _hoisted_14, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                            _createElementVNode("p", { class: "eyebrow" }, "PRODUCT PERFORMANCE"),
                            _createElementVNode("h2", null, "Best-selling products")
                        ], -1)),
                        _createVNode(_component_TrendingUp, {
                            size: 19,
                            class: "panel-icon",
                            "aria-hidden": "true"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_Package, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("p", null, "No product sales to rank yet.", -1))
                    ])
                ]),
                _createElementVNode("article", _hoisted_17, [
                    _createElementVNode("header", _hoisted_18, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                            _createElementVNode("p", { class: "eyebrow" }, "CLIENT VALUE"),
                            _createElementVNode("h2", null, "Highest client spend")
                        ], -1)),
                        _createVNode(_component_Users, {
                            size: 19,
                            class: "panel-icon",
                            "aria-hidden": "true"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_CircleDollarSign, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, "No client spending data to rank yet.", -1))
                    ])
                ])
            ]),
            _createElementVNode("section", _hoisted_21, [
                _createElementVNode("header", _hoisted_22, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "eyebrow" }, "LATEST ACTIVITY"),
                        _createElementVNode("h2", null, "Recent orders")
                    ], -1)),
                    _createVNode(_component_ClipboardList, {
                        size: 19,
                        class: "panel-icon",
                        "aria-hidden": "true"
                    })
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "table-scroll" }, [
                    _createElementVNode("table", { class: "orders-table" }, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Order"),
                                _createElementVNode("th", null, "Client"),
                                _createElementVNode("th", null, "Date"),
                                _createElementVNode("th", null, "Status"),
                                _createElementVNode("th", { class: "numeric" }, "Total")
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: "table-empty",
                                    colspan: "5"
                                }, "Recent orders will appear here when order data is available.")
                            ])
                        ])
                    ])
                ], -1))
            ])
        ])
    ]));
}
